<template>
  <v-card flat>
    <v-card-title class="pl-0 py-2">
      <v-icon v-if="error" color="error" class="mr-2">mdi-close-circle</v-icon>
      Dentate
    </v-card-title>
    <v-card-text class="pl-0">
      <v-btn-toggle v-model="dentate" class="rounded-10">
        <v-btn>
          <v-icon v-if="dentate === 'upper'" color="primary" class="mr-2">
            mdi-check-circle
          </v-icon>
          <v-icon v-if="dentate !== 'upper'" color="secondary" class="mr-2">
            mdi-circle
          </v-icon>
          Upper
        </v-btn>
        <v-btn>
          <v-icon v-if="dentate === 'lower'" color="primary" class="mr-2">
            mdi-check-circle
          </v-icon>
          <v-icon v-if="dentate !== 'lower'" color="secondary" class="mr-2">
            mdi-circle
          </v-icon>
          Lower
        </v-btn>
        <v-btn>
          <v-icon v-if="dentate === 'both'" color="primary" class="mr-2">
            mdi-check-circle
          </v-icon>
          <v-icon v-if="dentate !== 'both'" color="secondary" class="mr-2">
            mdi-circle
          </v-icon>
          Both
        </v-btn>
      </v-btn-toggle>
    </v-card-text>
    <v-fade-transition>
      <span class="error--text" v-if="error">
        {{ this.error }}
      </span>
    </v-fade-transition>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "NewOrderDentate",

  props: ["value"],

  inject: ["form"],

  data() {
    return {
      error: null
    }
  },

  computed: {
    ...mapGetters(["settings"]),

    dentate: {
      get() {
        return this.value
      },

      set(value) {
        if ([0, 1, 2].includes(value)) this.error = null
        const dentateMap = {
          0: "upper",
          1: "lower",
          2: "both"
        }
        this.$emit("input", dentateMap[value])
      }
    }
  },

  methods: {
    validate() {
      if (this.dentate === undefined) {
        this.error = "Dentate is Required"
      }
      return this.dentate !== undefined
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
